module.exports = __webpack_public_path__ + "static/newsletter-bg-3ef26af7f48722b77da1cb9b67f21187.webp";